import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  entityNaturalezaJuridicaAdapter,
  EntityNaturalezaJuridicaState
} from './entity-naturalezas-juridica.state';

const { selectEntities, selectAll } =
  entityNaturalezaJuridicaAdapter.getSelectors();

export const getError = (state: EntityNaturalezaJuridicaState): any =>
  state.error;

export const getIsLoading = (state: EntityNaturalezaJuridicaState): boolean =>
  state.isLoading;

export const selectNaturalezaJuridicaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.naturalezasJuridica
);

export const selectAllNaturalezaJuridica = createSelector(
  selectNaturalezaJuridicaState,
  selectAll
);
export const selectEntitiesNaturalezaJuridica = createSelector(
  selectNaturalezaJuridicaState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectNaturalezaJuridicaError = createSelector(
  selectNaturalezaJuridicaState,
  getError
);

// MemoizedSelector<object,any>
export const selectNaturalezaJuridicaIsLoading = createSelector(
  selectNaturalezaJuridicaState,
  getIsLoading
);
